export enum EContext {
    AUTOCOMPLETE,
    LIST_ITEMS,
}
